import { postMainApi, putMainApi, deleteMainApi, getMainApi, postSecureAccountsApi } from "@Shared/utils/ajax";
export const getCampaigns = (all, type) => {
  return getMainApi(all ? {} : {
    type
  }, "/remarketing/campaign");
};
export const createCampaign = details => {
  return postMainApi(details, "/remarketing/campaign");
};
export const updateCampaign = (campaignId, details) => {
  return putMainApi(details, `/remarketing/campaign/${campaignId}`);
};
export const addEmail = data => {
  return postMainApi(data, "/remarketing/email");
};
export const verifyEmail = emailId => {
  return postMainApi({
    emailId
  }, "/remarketing/email/verify");
};
export const getEmails = () => {
  return getMainApi({
    _type: "query"
  }, "/remarketing/email");
};
export const createList = data => {
  return postMainApi(data, "/remarketing/list");
};
export const updateList = (data, id) => {
  return putMainApi(data, `/remarketing/list/${id}`);
};
export const getList = (listId, offset = 0, limit = 10, orderBy = "updatedAt", orderType = "DESC", searchString = "") => {
  return getMainApi({
    offset,
    limit,
    orderBy,
    orderType,
    searchString: encodeURIComponent(searchString)
  }, `/remarketing/list/${listId}`);
};
export const getLists = () => {
  return getMainApi({}, "/remarketing/list");
};
export const getCampaignScheduleEmails = (campaignId, paginationData = {}) => {
  return getMainApi(paginationData, `/remarketing/campaign/${campaignId}/email`);
};
export const deleteList = listId => {
  return deleteMainApi(`/remarketing/list/${listId}`);
};
export const deleteCampaignScheduleEmail = (campaignId, scheduledEmailId) => {
  return postMainApi({}, `/remarketing/campaign/${campaignId}/email/${scheduledEmailId}`);
};
export const downloadListContacts = (listId, segmentId) => {
  const endpoint = `/remarketing/list/${listId}/download`;
  return getMainApi({
    segmentId
  }, endpoint);
};
export const deleteAllListContacts = listId => {
  return deleteMainApi(`/remarketing/list/${listId}/email`);
};
export const downloadCampaignResults = campaignId => {
  const endpoint = `/remarketing/campaign/${campaignId}/statistics/download`;
  return getMainApi({}, endpoint);
};
export const getCampaignStatistics = campaignId => {
  return getMainApi({}, `/remarketing/campaign/${campaignId}/statistics`);
};
export const getSegmentData = async () => {
  return getMainApi({}, "/remarketing/segment");
};
export const updateSegments = async (segments, listId) => {
  return putMainApi(segments, `/remarketing/list/${listId}/segment`);
};
export const updateEmailSubscribe = async (suppressed, listId, emailId) => {
  return putMainApi(suppressed, `/remarketing/list/${listId}/email/${emailId}`);
};
export const agreedToTerms = async () => {
  return postSecureAccountsApi({}, "/remarketing/agree-to-terms");
};
export const getSegmentList = async (listId, segmentId, offset = 0, limit = 10, orderBy = "updatedAt", orderType = "DESC", searchString = "") => {
  return getMainApi({
    offset,
    limit,
    orderBy,
    orderType,
    searchString: encodeURIComponent(searchString)
  }, `/remarketing/list/${listId}/segment/${segmentId}`);
};
export const cancelCampaign = campaignId => {
  return postMainApi({}, `/remarketing/campaign/${campaignId}/cancel`);
};